import React from 'react'
import {Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Heart} from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12">
          <div className="space-y-6">
            <img 
              src="https://static.lumi.new/material/1c/1c27b5241cc52be5b5d029ebb47804a8.png" 
              alt="Auto Star Logo" 
              className="h-16 sm:h-20 w-auto object-contain" 
            />
            <p className="text-white/60 leading-relaxed text-sm sm:text-base" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Votre mandataire automobile de confiance à Plan de Campagne, entre Aix-en-Provence et Marseille.
            </p>
            <div className="flex gap-4">
              <a href="#" className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-full p-3 hover:bg-blue-600 hover:border-blue-400 transition-all hover:scale-110">
                <Facebook className="text-white" size={20} />
              </a>
              <a href="#" className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-full p-3 hover:bg-gradient-to-br from-red-500 to-red-600 hover:border-red-400 transition-all hover:scale-110">
                <Instagram className="text-white" size={20} />
              </a>
              <a href="#" className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-full p-3 hover:bg-blue-500 hover:border-blue-400 transition-all hover:scale-110">
                <Linkedin className="text-white" size={20} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg sm:text-xl mb-4 sm:mb-6" style={{ fontFamily: 'Syne, sans-serif' }}>Navigation</h3>
            <ul className="space-y-3 sm:space-y-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <li><a href="#agence" className="text-white/70 hover:text-blue-400 transition-colors text-sm sm:text-base">Agence</a></li>
              <li><a href="#prestations" className="text-white/70 hover:text-white transition-colors text-sm sm:text-base">Prestations</a></li>
              <li><a href="#vehicules" className="text-white/70 hover:text-red-400 transition-colors text-sm sm:text-base">Véhicules</a></li>
              <li><a href="#contact" className="text-white/70 hover:text-blue-400 transition-colors text-sm sm:text-base">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg sm:text-xl mb-4 sm:mb-6" style={{ fontFamily: 'Syne, sans-serif' }}>Services</h3>
            <ul className="space-y-3 sm:space-y-4 text-white/70" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <li className="hover:text-blue-400 transition-colors cursor-pointer text-sm sm:text-base">Achat véhicules neufs</li>
              <li className="hover:text-white transition-colors cursor-pointer text-sm sm:text-base">Véhicules d'occasion</li>
              <li className="hover:text-red-400 transition-colors cursor-pointer text-sm sm:text-base">Import international</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer text-sm sm:text-base">Reprise & financement</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg sm:text-xl mb-4 sm:mb-6" style={{ fontFamily: 'Syne, sans-serif' }}>Contact</h3>
            <ul className="space-y-3 sm:space-y-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <li>
                <a href="tel:+33412333650" className="flex items-center gap-3 text-white/70 hover:text-blue-400 transition-colors group">
                  <div className="bg-blue-600/20 rounded-lg p-2 group-hover:bg-blue-600 transition-colors flex-shrink-0">
                    <Phone size={18} className="text-blue-400 group-hover:text-white" />
                  </div>
                  <span className="text-sm sm:text-base">04 12 33 36 50</span>
                </a>
              </li>
              <li>
                <a href="mailto:contact@autostar13.com" className="flex items-center gap-3 text-white/70 hover:text-red-400 transition-colors group">
                  <div className="bg-red-600/20 rounded-lg p-2 group-hover:bg-red-600 transition-colors flex-shrink-0">
                    <Mail size={18} className="text-red-400 group-hover:text-white" />
                  </div>
                  <span className="text-sm sm:text-base break-all">contact@autostar13.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <div className="bg-white/10 rounded-lg p-2 flex-shrink-0">
                  <MapPin size={18} className="text-white" />
                </div>
                <span className="text-sm sm:text-base">554 Route de Calas<br />Les Pennes Mirabeau 13170</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 mt-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-white/50 text-xs sm:text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>
            <p>© 2024 AUTO STAR. Tous droits réservés. SIRET: 97971652900024</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
